export default "__VITE_ASSET__9eb708c2__"